import theme from '@/style';
import {SVGProps} from '@/types';
import React from 'react';

const HomeChatSVG = ({color, width, height}: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || theme.iconSize.l}
    height={height || theme.iconSize.l}
    viewBox="0 0 25 24"
    fill={color || theme.basicColor.primary}>
    <path d="M18.7257 8.93881C21.8465 9.30456 24.2491 11.9599 24.2491 15.1556C24.2491 17.1192 23.3662 18.8552 21.9718 19.9935V20.847C21.9718 21.1316 21.687 21.4164 21.4025 21.4164H17.7316C16.0483 21.3444 14.5331 20.6026 13.4454 19.4535C16.6823 17.9775 18.9433 14.7127 18.9435 10.9378C18.9435 10.2522 18.8664 9.58347 18.7257 8.93881Z" />
    <path d="M8.59766 1.58984C13.2268 1.58993 16.9452 5.34633 16.9453 9.9375C16.9453 14.4148 13.3788 18.0952 8.93945 18.2852H4.04395C3.66457 18.285 3.28516 17.9058 3.28516 17.5264V16.3887C1.42588 14.8709 0.25 12.5557 0.25 9.9375C0.250103 5.34627 3.96848 1.58984 8.59766 1.58984ZM4.5 9C3.80964 9 3.25 9.55964 3.25 10.25C3.25 10.9404 3.80964 11.5 4.5 11.5C5.19036 11.5 5.75 10.9404 5.75 10.25C5.75 9.55964 5.19036 9 4.5 9ZM9 9C8.30964 9 7.75 9.55964 7.75 10.25C7.75 10.9404 8.30964 11.5 9 11.5C9.69036 11.5 10.25 10.9404 10.25 10.25C10.25 9.55964 9.69036 9 9 9ZM13.5 9C12.8096 9 12.25 9.55964 12.25 10.25C12.25 10.9404 12.8096 11.5 13.5 11.5C14.1904 11.5 14.75 10.9404 14.75 10.25C14.75 9.55964 14.1904 9 13.5 9Z" />
  </svg>
);

export default HomeChatSVG;
